import { AssignStatus } from "@/enum/list.enum";

import { ListPerson } from "../../List/schema/list";
import { Tabs } from "../pages/Outbox/outboxTabs";
import { prospectHasCampaign } from "./prospectHasCampaign";

/**
 * Picks the Outbox content tab a prospect should land on by default.
 *
 * Mirrors ReadyToSend's auto-switch, with an Outbox-specific override: once a
 * prospect's outreach is finished (assignStatus ENDED or MESSAGE_SENT) the Chat
 * tab is shown so the user lands on the conversation rather than the sequence.
 *
 * - ENDED / MESSAGE_SENT → Chat (conversation view of completed outreach)
 * - otherwise, has a campaign → Campaign
 * - otherwise → Chat
 */
export const resolveOutboxAutoTab = (prospect: ListPerson): Tabs => {
	if (
		prospect.assignStatus === AssignStatus.ENDED ||
		prospect.assignStatus === AssignStatus.MESSAGE_SENT
	) {
		return Tabs.CHAT;
	}

	return prospectHasCampaign(prospect) ? Tabs.CAMPAIGN : Tabs.CHAT;
};
